import {Injectable} from '@angular/core';
import {LocalTrabajadorRepository} from "../../data/datasource/local/trabajador/local.trabajador.repository";
import {Trabajador} from "../models/trabajador.model";

@Injectable({
    providedIn: 'root'
})
export class SecurityService {

    constructor(
        private localTrabajadorRepository: LocalTrabajadorRepository
    ) {
    }

    public existeSesion() {
        const token = this.localTrabajadorRepository.obtenerToken();
        return token && token != '';
    }

    public usuarioLogeado(): Trabajador {
        //return this.localTrabajadorRepository.obtenerTrabajadorSesion();
        return Trabajador.build(JSON.parse(localStorage.getItem('trabajadorSesion')));
    }
    public localIdSesion(): string {
        const usuarioLogeado: any = this.usuarioLogeado();
        if (usuarioLogeado) {
            return usuarioLogeado.local_id;
        }
    }


}

